import React, { useState } from 'react'
import classNames from 'classnames'
import queryString from 'query-string'

import style from './style.module.scss'

function DeleteAlarmContent(props: any) {
    const { onClose, alarmId, deleteAlarm } = props
    const { mobile } = queryString.parse(location.search)
    const isMobile = mobile === 'true'
    const [isDeleting, setIsDeleting] = useState(false)

    const handleDeleteAlarm = async () => {
        try {
            setIsDeleting(true)
            const response = await deleteAlarm(alarmId)

            onClose()
        } catch (error) {
            console.error('Error deleting alarm:', error)
        } finally {
            setIsDeleting(false)
        }
    }
    return (
        <div className={classNames(style.content, {
            [style.isFullscreen]: isMobile,
        })}>
            <p style={{ marginBottom: '10px' }}>You're requesting to delete alarm.</p>
            <p>Click DELETE to confirm</p>

            <div className={style.buttons}>
                <button
                    className={style.cancelButton}
                    onClick={() => {
                        onClose()
                        props.history.push(`/alarm`)
                    }}
                    disabled={isDeleting}
                >
                    No, Keep Alarm
                </button>
                <button
                    className={style.confirmButton}
                    disabled={isDeleting}
                    onClick={handleDeleteAlarm}
                >
                   Yes, Delete Alarm
                </button>
            </div>
        </div>
    )
}

export default DeleteAlarmContent